<template>
  <div class="base-bg" v-if="visible">
    <TopBar :title="$t('edit.editActionTitles.menuSets')" @onClickClose="close" @onClickSave="handleSubmit" :right-btn="userInfo.level > 0 || userInfo.team_id > 0"></TopBar>
    <div class="set-content">
      <div class="c-tab-container">
        <div class="c-tab-scroll" ref="menuTitles">
          <div class="c-wrapper" >
            <div
              class="c-tab"
              v-for="(item, index) in menuList"
              :key="index"
              :class="{active: item.num === currTab.num}"
              @click="onClickTab(item)"
            >{{$t('edit.menu') + item.num}}</div>
          </div>
        </div>
        <div class="c-add" @click="addMenu" v-if="userInfo.level > 0 || userInfo.team_id > 0">{{$t('publish.tagAdd')}}</div>
      </div>
      <div class="mob-menu">
        <Menu-item
          :isPc="false"
          v-if="currTab"
          :selectOptions="selectOptions"
          :item="currTab"
          @del="delMenu"
          @changSource="changSource"
        ></Menu-item>
      </div>
    </div>
  </div>
</template>

<script>
// import { Tab, TabItem } from "@/components/Tab";
import TopBar from "./TopBar.vue";
import MenuItem from "../../../component/setting/component/MenuItem.vue";
import { mapGetters } from "vuex";

export default {
  components: { TopBar, MenuItem },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      menuList: [],
      menuIndex: 0,
      selectOptions: [
        { id: 1, value: 1, title: this.$t("edit.link"), disabled: false },
        { id: 2, value: 2, title: this.$t("edit.phone"), disabled: false },
        { id: 3, value: 3, title: this.$t("edit.mapAddress"), disabled: false },
        { id: 4, value: 4, title: this.$t("edit.picText"), disabled: false },
        { id: 5, value: 5, title: this.$t("edit.video"), disabled: false },
      ],
      currTab: null,
    };
  },
  computed: { ...mapGetters(["vrbase","userInfo"]) },
  created() {
    this.menuList = this.$deepClone(this.vrbase.menus);
    if (this.menuList.length) {
      this.menuList.forEach((item) => {
        this.menuIndex++;
        item.num = this.menuIndex;
      });
      this.currTab = this.menuList[0];
      console.log("menuList Clone =>", this.menuList);
    }
  },
  methods: {
    close() {
      this.$emit("close");
    },
    handleSubmit() {
      console.log("menuList==save", this.menuList);
      for (var i = 0; i < this.menuList.length; i++) {
        const menu = this.menuList[i];
        if(menu.title === "" || menu.content === "") {
          this.$message.error(`${this.$t('edit.menu')}${menu.num}${this.$t('descriptions.noFinish')}`)
          return;
        }
      }
      const vrbase = { ...this.vrbase, menus: this.menuList }
      this.$store
        .dispatch("saveVRBase", { vrbase, showLoading: true,})
        .then(() => {});
    },
    addMenu() {
      this.menuIndex++;
      this.currTab = {
        // content: "",
        num: this.menuIndex,
        title: "",
        type: null,
      };
      this.menuList.push(this.currTab);
      this.$nextTick(() => {
        let menu = this.$refs["menuTitles"];
        menu.scrollLeft = menu.scrollWidth;
      })
    },
    delMenu(num) {
      let index = null;
      this.menuList.find((v, i, arr) => {
        if (v.num === num) {
          index = i;
          return;
        }
      });
      this.menuList.splice(index, 1);
      const length = this.menuList.length;
      if (length > 0) {
        // this.menuIndex = length - 1;
        this.currTab = this.menuList[length - 1];
        this.menuIndex = length;
      } else {
        this.menuIndex = 0;
        this.currTab = null;
      }
    },
    changSource(item) {
      const num = item.num;
      this.menuList.forEach((v, i) => {
        if (v.num === num) {
          this.$set(this.menuList, i, item);
        }
      });
      console.log("this.menuList=", this.menuList)
    },
    onClickTab(item) {
      // debugger
      this.currTab = null;
      console.log(this.currTab, item);
      this.currTab = Object.assign({}, item);
      console.log('this.currTab',this.currTab)
    },
  },
};
</script>

<style lang="less" scoped>
.base-bg {
  /deep/ .ant-input,
  /deep/ .ant-select-selection,
  /deep/ .ant-input-number-input {
    background-color: #333 !important;
    border: 1px solid #555;
    color: #fff;
  }

  /deep/ .ant-form-item-label > label {
    color: #fff !important;
  }

  /deep/ span + * {
    color: #fff;
  }
  .c-tab-container {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .c-tab-scroll {
      width: calc(100% - 60px);
      overflow-x: auto;
      .c-wrapper {
        width: 100%;
        display: flex;
        .c-tab {
          min-width: 70px;
          max-width: 90px;
          text-align: center;
          color: #a2a2a2;
        }
        .active {
          border-bottom: 2px solid #ffffff;
          color: #ffffff;
        }
      }
    }
    .c-tab-scroll::-webkit-scrollbar {
      display: none;
    }
    .c-add {
      width: 60px;
      text-align: center;
      height: 25px;
      background: #999999;
      border-radius: 2px;
      line-height: 25px;
      margin-left: 5px;
    }
    // }
  }
}
</style>
